import { RootState } from '../root.reducers';
import { AfWhitelist } from './afWhitelist.types';

export const getAfWhitelistList = (state: RootState): AfWhitelist[] =>
  state.afWhitelist.entities;

export const getAfWhitelist = (state: RootState): AfWhitelist | null =>
  state.afWhitelist.single;

export const getSelectedAfWhitelist = (state: RootState): AfWhitelist[] =>
  state.afWhitelist.selected;

export const getAfWhitelistCreatedId = (state: RootState): string | null =>
  state.afWhitelist.createdId;

export const isAfWhitelistCreatePopupOpen = (state: RootState): boolean =>
  state.afWhitelist.ui.isCreatePopupOpen;

export const isAfWhitelistLoading = (state: RootState): boolean =>
  state.afWhitelist.ui.isLoading;
